import * as types from '../actions/actionTypes';
import initialState from './initialState';
import { assign } from '../shared/Assign';

function getSpeedFormated(time, loaded): string {
    let duration = (new Date().getTime() - time) / 1000;

    let speedBitps = (loaded * 8) / duration;

    if (speedBitps > 1024 * 1024) {
        return (speedBitps / 1024 / 1024).toFixed(2) + ' Mbit/s';
    } else if (speedBitps > 1024) {
        return (speedBitps / 1024).toFixed(2) + ' kbit/s';
    } else {
        return speedBitps.toFixed(2) + ' bit/s';
    }
}

function getBytesFormated(bytes): string {
    if (bytes > 1024 * 1024 * 1024) {
        return (bytes / 1024 / 1024 / 1024).toFixed(2) + ' Gb';
    } else if (bytes > 1048576) {
        /* 1024 * 1024 */
        return (bytes / 1024 / 1024).toFixed(2) + ' Mb';
    } else if (bytes > 1000) {
        return (bytes / 1024).toFixed(2) + ' kb';
    } else {
        return bytes.toFixed(2) + ' b';
    }
}

export default function downloadReducer(
    state: any = initialState.download,
    action: { type: string; download: any }
) {
    switch (action.type) {
        case types.DOWNLOAD_STARTED: {
            const newState = assign({}, state);
            newState.isRunning = true;
            newState.total = 0;
            newState.loaded = 0;
            return newState;
        }
        case types.DOWNLOAD_INIT_PROGRESS: {
            const newState = assign({}, state);
            newState.total = action.download.total;
            newState.startTime = new Date();
            return newState;
        }
        case types.DOWNLOAD_PROGRESS: {
            const newState = assign({}, state);

            newState.loaded = action.download.loaded;
            newState.speed =
                getSpeedFormated(state.startTime.getTime(), action.download.loaded) +
                ' - ' +
                getBytesFormated(newState.loaded) +
                '/' +
                getBytesFormated(newState.total);
            return newState;
        }
        case types.DOWNLOAD_COMPLETED: {
            const newState = assign({}, state);
            newState.isRunning = false;
            newState.loaded = 1;
            newState.total = 1;
            return newState;
        }
        case types.DOWNLOAD_PROGRESS_NOT_SUPPORTED: {
            const newState = assign({}, state);
            newState.loaded = 1;
            newState.total = 1;
            newState.speed = 'Download progress not supported. Downloading...';
            return newState;
        }
        case types.DOWNLOAD_ERROR: {
            const newState = assign({}, state);
            newState.isRunning = false;
            return newState;
        }
        default:
            return state;
    }
}
